/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";

import type { FcWithoutChildren } from "types/fcWithoutChildren";

type Props = {
  addToWatchList: (itemId: string) => void;
  isWatched: boolean;
  itemId: string | undefined;
};

export const AddToWatchListButton: FcWithoutChildren<Props> = (props) => {
  const { addToWatchList, isWatched, itemId } = props;

  if (itemId === undefined) return null;

  // TODO: 多言語対応
  const buttonLabel = isWatched ? "さくじょ" : "ついか";
  const handleAddToWatchList = () => {
    addToWatchList(itemId);
  };

  return (
    <button css={rootStyle} onClick={handleAddToWatchList}>
      {/* TODO: 多言語対応 */}
      ウォッチ{buttonLabel}
    </button>
  );
};

const rootStyle = css`
  background-color: white;
  border: 1px solid black;
  color: black;
`;
